import React from "react";
import styled from "styled-components";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";

import { formatDay } from "../Issues/dates";

/**
 * The way into the compare drawer: whether the page's traffic moved to another page, with how many
 * pages the drawer offers for the issue start.
 */
export default function CompareCall({ offered, since, onOpen }) {
    return (
        <Bar>
            <Icon><CompareArrowsIcon style={{ fontSize: "1.1rem" }} /></Icon>
            <Text>
                <Question>Did the traffic move to another page?</Question>
                {offered > 0 && since && <Detail>{offered} pages rose on or after {formatDay(since)}</Detail>}
            </Text>
            <Button type="button" onClick={onOpen}>Find where it went</Button>
        </Bar>
    );
}

const Bar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid #c7d2fe;
    border-radius: 10px;
    background: #eef2ff;
    @media (max-width: 600px) { flex-wrap: wrap; }
`;

const Icon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #fff;
    color: #4f46e5;
`;

const Text = styled.div`
    flex: 1;
    min-width: 0;
`;

const Question = styled.div`
    font-size: 0.84rem;
    font-weight: 700;
    color: #1e1b4b;
`;

const Detail = styled.div`
    margin-top: 2px;
    font-size: 0.72rem;
    color: #4338ca;
`;

const Button = styled.button`
    flex-shrink: 0;
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    background: #4f46e5;
    font-size: 0.78rem;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(79, 70, 229, 0.3);
    &:hover { background: #4338ca; }
    @media (max-width: 600px) { width: 100%; }
`;
